import { TableHeader } from "app/components/Table/types";
import { BoardViewType } from "app/types";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as boardSettingActions } from "app/containers/Features/containers/Boards/components/Settings/redux/slice";
import HiddenGroups from "../../../Home/components/ColumnComponents/HiddenGroups";
import {
  selectGroupingLoader,
  selectGroupingTicketsLoader,
} from "../../redux/selector";
import { GroupBlock } from "./GroupBlock";
import {
  getUpdatedColumns,
  mergeListColumnWidthsIntoCustomizeCards,
} from "./helper";
import { ListViewProps } from "./types";

export const ListView: React.FC<ListViewProps> = ({
  boardData,
  selectedTickets,
  groups,
}) => {
  const dispatch = useDispatch();
  const groupLoading = useSelector(selectGroupingLoader);
  const groupTicketsLoading = useSelector(selectGroupingTicketsLoader);

  const [cols, setCols] = useState<TableHeader[]>(
    getUpdatedColumns(boardData?.customizeCards),
  );

  useEffect(() => {
    if (boardData) {
      setCols(getUpdatedColumns(boardData?.customizeCards));
    }
  }, [boardData]);

  const handleCommitColumnWidths = useCallback(
    (colsSnapshot: TableHeader[]) => {
      if (!boardData?._id || !boardData.customizeCards?.length) return;
      dispatch(
        boardSettingActions.setCustomizeCardOrder(
          mergeListColumnWidthsIntoCustomizeCards(
            boardData.customizeCards,
            colsSnapshot,
          ),
        ),
      );
      dispatch(
        boardSettingActions.updateCustomizeCard({
          id: boardData._id,
          callback: () => {},
          silent: true,
        }),
      );
    },
    [boardData, dispatch],
  );

  const gridTemplate = useMemo(
    () => cols.map((c) => `${c.width}px`).join(" "),
    [cols],
  );

  const minTableWidth = useMemo(
    () => cols.reduce((s, c) => s + Number(c.width), 0),
    [cols],
  );

  const sortedGroups = useMemo(
    () => [...groups].sort((a, b) => a.order - b.order),
    [groups],
  );
  return (
    <div className="w-full relative">
      {sortedGroups?.map((g, idx) => {
        return (
          g.isVisible && (
            <GroupBlock
              key={g._id}
              group={g}
              idx={idx}
              gridTemplate={gridTemplate}
              cols={cols} // ✅ FIXED
              minTableWidth={minTableWidth}
              setCols={setCols}
              boardData={boardData}
              selectedTickets={selectedTickets}
              onDragEnd={() => {}}
              groupLoading={groupLoading}
              groupTicketsLoading={groupTicketsLoading}
              onCommitColumnWidths={handleCommitColumnWidths}
            />
          )
        );
      })}
      <HiddenGroups type={BoardViewType.LIST} minTableWidth={minTableWidth} />
    </div>
  );
};
